 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A780743299084_COV from '@/components/9780743299084_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A780743299084_TITLEPAGE_01 from '@/components/9780743299084_titlePage_01'
 import A780743299084_DEDICATIONPAGE_01 from '@/components/9780743299084_dedicationPage_01'
 import A780743299084_EPIGRAPHPAGE_01 from '@/components/9780743299084_epigraphPage_01'
 import A780743299084_CH_1 from '@/components/9780743299084_ch_1'
 import A780743299084_CH_2 from '@/components/9780743299084_ch_2'
 import A780743299084_CH_3 from '@/components/9780743299084_ch_3'
 import A780743299084_CH_4 from '@/components/9780743299084_ch_4'
 import A780743299084_CH_5 from '@/components/9780743299084_ch_5'
 import A780743299084_CH_6 from '@/components/9780743299084_ch_6'
 import A780743299084_CH_7 from '@/components/9780743299084_ch_7'
 import A780743299084_CH_8 from '@/components/9780743299084_ch_8'
 import A780743299084_CH_9 from '@/components/9780743299084_ch_9'
 import A780743299084_CH_10 from '@/components/9780743299084_ch_10'
 import A780743299084_CH_11 from '@/components/9780743299084_ch_11'
 import A780743299084_CH_12 from '@/components/9780743299084_ch_12'
 import A780743299084_CH_13 from '@/components/9780743299084_ch_13'
 import A780743299084_CH_14 from '@/components/9780743299084_ch_14'
 import A780743299084_CH_15 from '@/components/9780743299084_ch_15'
 import A780743299084_CH_16 from '@/components/9780743299084_ch_16'
 import A780743299084_CH_17 from '@/components/9780743299084_ch_17'
 import A780743299084_CH_18 from '@/components/9780743299084_ch_18'
 import A780743299084_CH_19 from '@/components/9780743299084_ch_19'
 import A780743299084_CH_20 from '@/components/9780743299084_ch_20'
 import A780743299084_CH_21 from '@/components/9780743299084_ch_21'
 import A780743299084_CH_22 from '@/components/9780743299084_ch_22'
 import A780743299084_CH_23 from '@/components/9780743299084_ch_23'
 import A780743299084_CH_24 from '@/components/9780743299084_ch_24'
 import A780743299084_CH_25 from '@/components/9780743299084_ch_25'
 import A780743299084_CH_26 from '@/components/9780743299084_ch_26'
 import A780743299084_CH_27 from '@/components/9780743299084_ch_27'
 import A780743299084_CH_28 from '@/components/9780743299084_ch_28'
 import A780743299084_CH_29 from '@/components/9780743299084_ch_29'
 import A780743299084_CH_30 from '@/components/9780743299084_ch_30'
 import A780743299084_CH_31 from '@/components/9780743299084_ch_31'
 import A780743299084_CH_32 from '@/components/9780743299084_ch_32'
 import A780743299084_CH_33 from '@/components/9780743299084_ch_33'
 import A780743299084_CH_34 from '@/components/9780743299084_ch_34'
 import A780743299084_CH_35 from '@/components/9780743299084_ch_35'
 import A780743299084_CH_36 from '@/components/9780743299084_ch_36'
 import A780743299084_CH_37 from '@/components/9780743299084_ch_37'
 import A780743299084_CH_38 from '@/components/9780743299084_ch_38'
 import A780743299084_CH_39 from '@/components/9780743299084_ch_39'
 import A780743299084_CH_40 from '@/components/9780743299084_ch_40'
 import A780743299084_CH_41 from '@/components/9780743299084_ch_41'
 import A780743299084_CH_42 from '@/components/9780743299084_ch_42'
 import A780743299084_CH_43 from '@/components/9780743299084_ch_43'
 import A780743299084_CH_44 from '@/components/9780743299084_ch_44'
 import A780743299084_CH_45 from '@/components/9780743299084_ch_45'
 import A780743299084_CH_46 from '@/components/9780743299084_ch_46'
 import A780743299084_CH_47 from '@/components/9780743299084_ch_47'
 import A780743299084_CH_48 from '@/components/9780743299084_ch_48'
 import A780743299084_CH_49 from '@/components/9780743299084_ch_49'
 import A780743299084_CH_50 from '@/components/9780743299084_ch_50'
 import A780743299084_CH_51 from '@/components/9780743299084_ch_51'
 import A780743299084_BM_1 from '@/components/9780743299084_bm_1'
 import SS_RECOMMENDPAGE from '@/components/SS_recommendpage'
 import A780743299084_BM_2 from '@/components/9780743299084_bm_2'
 import A780743299084_ALF from '@/components/9780743299084_alf'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
 import A780743299084_CRP from '@/components/9780743299084_crp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9780743299084_cov",
 			"name" : "9780743299084_cov",
 			"component" : A780743299084_COV
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9780743299084_titlePage_01",
 			"name" : "9780743299084_titlePage_01",
 			"component" : A780743299084_TITLEPAGE_01
 		},
 		{
 			"path" : "/9780743299084_dedicationPage_01",
 			"name" : "9780743299084_dedicationPage_01",
 			"component" : A780743299084_DEDICATIONPAGE_01
 		},
 		{
 			"path" : "/9780743299084_epigraphPage_01",
 			"name" : "9780743299084_epigraphPage_01",
 			"component" : A780743299084_EPIGRAPHPAGE_01
 		},
 		{
 			"path" : "/9780743299084_ch_1",
 			"name" : "9780743299084_ch_1",
 			"component" : A780743299084_CH_1
 		},
 		{
 			"path" : "/9780743299084_ch_2",
 			"name" : "9780743299084_ch_2",
 			"component" : A780743299084_CH_2
 		},
 		{
 			"path" : "/9780743299084_ch_3",
 			"name" : "9780743299084_ch_3",
 			"component" : A780743299084_CH_3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js